import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=fb2d0edc&"
import script from "./ErrorBox.vue?vue&type=script&lang=js&"
export * from "./ErrorBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports